import useCurrencyNumber from '@/hooks/useCurrencyNumber'
import { Switcher } from '../Switcher'

interface AffiliateDiscountSelectProps {
  className?: string
  label: string
  description: string
  price?: number
  value?: boolean
  onChange?: (value: boolean) => void
}

const AffiliateDiscountSelect = ({
  className = '',
  description,
  label,
  price,
  value,
  onChange,
}: AffiliateDiscountSelectProps) => {
  const format = useCurrencyNumber()

  return (
    <div className={`flex justify-between gap-2 ${className}`}>
      <div>
        <p className='text-sm font-semibold'>
          {label}
          {!!price && (
            <span className='ml-1 text-price'>({format(price)})</span>
          )}
        </p>
        <p className='text-xs'>
          <i>{description}</i>
        </p>
      </div>
      <Switcher value={value} onChange={onChange} />
    </div>
  )
}

export default AffiliateDiscountSelect
